import React, { useEffect, useState } from 'react';
import { account, ID, OAuthProvider } from './appwriteConfig';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';



export default function AppwriteHomePage() {
  const { user, loading, login, isSubscriber, getCurrentUser } = useAuth();
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [currentUser, setCurrentUser] = useState(null);

  /* async function login(email, password) {
    await account.createEmailPasswordSession(email, password);
    setLoggedInUser(await account.get());
    console.log(loggedInUser)
  } */

  const loginWithGoogle = async () => {
    try {
      await account.createOAuth2Session(OAuthProvider.Google)
      console.log("got here")
    } catch (error) {
      console.log(error)
    }
  }

  const creatGoogle = async () => {
    account.createOAuth2Session(
      OAuthProvider.Google, // provider
      'https://google.com/', // redirect here on success
      'https://localhost:44442/', // redirect here on failure
  );
  
  }

  async function getUser() {
    try {
      setLoggedInUser(user);
      console.log(user.labels);
      console.log("User: " + isSubscriber());
    } catch (error) {
      console.log("No one logged in!")
    }
  }

  useEffect(() => {
    if(!loading && user) {
      getUser();
    }
  }, [loading, user]);

  return (
    <>
       <div>
      <p>
        {loading ? 'Loading...' : loggedInUser ? `Logged in as ${loggedInUser.name}` : 'Not logged in'}
      </p>

      {isSubscriber() ? <h1>You are a subscriber!</h1> : <></>}

      <form>
        <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} />
        <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
        <input type="text" placeholder="Name" value={name} onChange={e => setName(e.target.value)} />

        <button type="button" onClick={() => login(email, password)}>
          Login
        </button>
        <button onClick={creatGoogle}>Login with Google</button>

        <button
          type="button"
          onClick={async () => {
            await account.create(ID.unique(), email, password, name);
            login(email, password);
          }}
        >
          Register
        </button>

        <button
          type="button"
          onClick={async () => {
            await account.deleteSession('current');
            setLoggedInUser(null);
          }}
        >
          Logout
        </button>
      </form>
    </div>
    <div>
      {loggedInUser ? <h1>You have to be logged in to see this!</h1> : <></>}

    </div>

    
    
    </>
  );
}
